import React from 'react';
import { useLanguage } from '../../contexts/LanguageContext';
import { forYouReasonLabel } from '../../utils/forYou';

/** Small "why this piece" chip under a "For you" card (nothing for `new`). */
const ForYouReason = ({ item }) => {
  const { t } = useLanguage();
  const label = forYouReasonLabel(item);
  if (!label) return null;
  return (
    <p className="mt-1.5 min-w-0 px-1 text-[13px] font-semibold text-foreground" data-testid="for-you-reason">
      <span className="inline-flex max-w-full rounded-full bg-panel px-2.5 py-1"><span className="truncate">{t(label)}</span></span>
    </p>
  );
};

export default ForYouReason;
